import { all, fork } from 'redux-saga/effects';

import { account } from './account/actions';
import { security } from './security/actions';

export function* settings() {
  yield all([fork(account), fork(security)]);
}
